import React from 'react';

import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import WorklistSearchInput, {WorklistSearchInputProps} from 'worklists/WorklistSearchInput';

interface Props extends WorklistSearchInputProps {
  disabled?: boolean;
  autoFocus?: boolean;
  required?: boolean;
  label: string;
}

export default function ExistingWorklistFormGroup(props: Props): JSX.Element {
  return (
    <Row>
      <Col sm={12}>
        <FormGroup>
          {props.label !== '' && <Label required={props.required}>{props.label}</Label>}
          <WorklistSearchInput
            autoFocus={props.autoFocus}
            worklistTypes={props.worklistTypes}
            onChange={props.onChange}
            disabled={props.disabled}
          />
        </FormGroup>
      </Col>
    </Row>
  );
}
